var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_1027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.325 12.1334C13.925 11.4167 12.1084 10.8334 10 10.8334C7.89171 10.8334 6.07504 11.4167 4.67504 12.1334C3.84171 12.5584 3.33337 13.4167 3.33337 14.35V16.6667H16.6667V14.35C16.6667 13.4167 16.1584 12.5584 15.325 12.1334ZM15 15H5.00004V14.35C5.00004 14.0334 5.16671 13.75 5.43337 13.6167C6.42504 13.1084 8.02504 12.5 10 12.5C11.975 12.5 13.575 13.1084 14.5667 13.6167C14.8334 13.75 15 14.0334 15 14.35V15Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 10C11.8417 10 13.3334 8.50833 13.3334 6.66667C13.3334 5.525 13.3334 3.75 13.3334 3.75C13.3334 3.05833 12.7751 2.5 12.0834 2.5C11.6501 2.5 11.2667 2.725 11.0417 3.05833C10.8167 2.725 10.4334 2.5 10.0001 2.5C9.56675 2.5 9.18341 2.725 8.95841 3.05833C8.73341 2.725 8.35008 2.5 7.91675 2.5C7.22508 2.5 6.66675 3.05833 6.66675 3.75C6.66675 3.75 6.66675 5.51667 6.66675 6.66667C6.66675 8.50833 8.15841 10 10.0001 10ZM8.33341 4.58333H11.6667V6.66667C11.6667 7.58333 10.9167 8.33333 10.0001 8.33333C9.08341 8.33333 8.33341 7.58333 8.33341 6.66667V4.58333Z",
    fill: "#4F4F4F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_1027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileIcon);
export default __webpack_public_path__ + "static/media/profile_icon.09b224b8f289e4be7c0a8f49e0560abf.svg";
export { ForwardRef as ReactComponent };